import PropTypes from 'prop-types'

import { Line as CanvasLine, Group } from 'react-konva'

import { getHighlightedColor } from '../../services/colorsService'
import { getViewBoxFromAnnotationCoordinates } from '../../helpers'

const Stroke = ({
  annotation,
  annotationRef,
  opacity,
  hovered,
  hoverProps,
  selected,
  selectionProps,
  contextMenuProps,
  dragAndDropProps,
  children,
}) => {
  const position = Stroke.getXY(annotation)
  const points = Stroke.getLinePoints(annotation)
  const anchor = Stroke.getAnchor(annotation)

  const commonStyles = {
    lineCap: 'round',
    lineJoin: 'round',
    opacity,
  }

  const styles = {
    ...commonStyles,
    stroke: annotation.Color,
    strokeWidth: annotation.Width,
    hitStrokeWidth: annotation.Width * 2,
  }

  const hoveredStyles = {
    ...commonStyles,
    stroke: getHighlightedColor(annotation.Color),
    strokeWidth: 1,
    strokeHitEnabled: false,
    strokeScaleEnabled: false,
  }

  return (
    <Group {...position} {...dragAndDropProps}>
      <CanvasLine
        id={annotation.Id}
        ref={annotationRef}
        points={points}
        {...styles}
        {...hoverProps}
        {...selectionProps}
        {...contextMenuProps}
      />
      {(selected || hovered) && <CanvasLine points={points} {...hoveredStyles} />}
      <Group {...anchor}>{children}</Group>
    </Group>
  )
}

Stroke.getXY = (annotation) => ({
  x: annotation.Coordinates[0].Start.X,
  y: annotation.Coordinates[0].Start.Y,
})

Stroke.getAnchor = () => ({
  x: 0,
  y: 0,
})

Stroke.getLinePoints = (annotation) => {
  const points = []
  const position = Stroke.getXY(annotation)

  for (const coordinates of annotation.Coordinates) {
    points.push(coordinates.Start.X - position.x)
    points.push(coordinates.Start.Y - position.y)
    points.push(coordinates.End.X - position.x)
    points.push(coordinates.End.Y - position.y)
  }

  return points
}

Stroke.getViewBox = getViewBoxFromAnnotationCoordinates

Stroke.propTypes = {
  annotation: PropTypes.shape({
    Id: PropTypes.number,
    Color: PropTypes.string.isRequired,
    Coordinates: PropTypes.arrayOf(
      PropTypes.shape({
        Start: PropTypes.shape({
          X: PropTypes.number.isRequired,
          Y: PropTypes.number.isRequired,
        }),
        End: PropTypes.shape({
          X: PropTypes.number.isRequired,
          Y: PropTypes.number.isRequired,
        }),
      })
    ).isRequired,
    Width: PropTypes.number.isRequired,
  }).isRequired,
  annotationRef: PropTypes.func,
  opacity: PropTypes.number,
  selected: PropTypes.bool,
  selectionProps: PropTypes.shape({
    onClick: PropTypes.func.isRequired,
  }),
  hovered: PropTypes.bool,
  hoverProps: PropTypes.shape({
    onMouseEnter: PropTypes.func.isRequired,
    onMouseLeave: PropTypes.func.isRequired,
  }),
  contextMenuProps: PropTypes.shape({
    onContextMenu: PropTypes.func.isRequired,
  }),
  dragAndDropProps: PropTypes.shape({
    onDragStart: PropTypes.func.isRequired,
    onDragEnd: PropTypes.func.isRequired,
  }),
  children: PropTypes.node,
}

export default Stroke
